import { useNavigate } from 'react-router-dom';

const MsgNetError = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-slate-900/50 rounded-lg px-6 py-8 text-center border border-red-500/30">
          {/* Icono de error */}
          <div className="mx-auto w-16 h-16 mb-4 rounded-full bg-red-500/20 grid place-items-center">
            <svg
              className="w-8 h-8 text-ccnorte"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          {/* Título */}
          <h3 className="text-xl font-semibold text-white font-montserrat mb-2">
            Se produjo un error
          </h3>

          {/* Mensaje descriptivo */}
          <p className="text-sm text-slate-400 font-montserrat">
            No se pudo cargar la información.
          </p>

          {/* Botones */}
          <div className="mt-6 flex flex-col gap-3 items-center">
            <button
              onClick={() => navigate('/')}
              className="px-6 py-2 bg-ccnorte hover:bg-red-500 text-white rounded-lg font-montserrat text-sm transition-colors"
            >
              Ir al inicio
            </button>

            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-ccnorte hover:bg-red-500 text-white rounded-lg font-montserrat text-sm transition-colors"
            >
              Recargar página
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MsgNetError;
